import React, { ReactElement } from "react";
import Bounce from "react-reveal/Bounce";

export interface IBaseCard {
  title?: string;
  children: ReactElement[] | ReactElement;
  increaseHeight?: boolean;
}

export default function BaseCard(props: IBaseCard) {
  return (
    <Bounce top duration={500}>
      <div className="rounded-3xl px-8 py-10 relative gap-6 inline-flex flex-col w-[500px] items-center drop-shadow-xl bg-[rgba(255,254,252,1)] text-brij-DarkGrey max-h-[90vh]">
        {props.title && (
          <p className="h-6 w-full text-left text-heading3 font-medium text-brij-Black">
            {props.title}
          </p>
        )}
        <div
          className={`flex flex-col overflow-y-scroll w-full items-center gap-6 px-4 ${
            props.increaseHeight ? "h-[500px]" : ""
          }`}
        >
          {props.children}
        </div>
      </div>
    </Bounce>
  );
}
